// config:
// constructor
// hpToken
// maxHp
// editorSymbol
// blockMove
// blockBoosterChange
// blockMatch

G.BoardLayer = function(board, config) {
  Phaser.Group.call(this, game);

  this.position = board.position;
  this.scale = board.scale;

  this.board = board;
  this.boardData = board.boardData;
  this.config = config;

  this.grid = new G.GridArray(this.boardData.width, this.boardData.height, false);
};

G.BoardLayer.prototype = Object.create(Phaser.Group.prototype);

G.BoardLayer.prototype.clearLayer = function() {
  this.grid.loop(function(elem, cellX, cellY) {
    if (elem) this.removeToken(cellX, cellY);
  }, this);
};

G.BoardLayer.prototype.isMoveBlocked = function(cellX, cellY) {
  return this.isToken(cellX, cellY) && this.config.blockMove;
};

G.BoardLayer.prototype.isMatchBlocked = function(cellX, cellY) {
  return this.isToken(cellX, cellY) && this.config.blockMatch;
};

G.BoardLayer.prototype.isBoosterChangeBlocked = function(cellX, cellY) {
  return this.isToken(cellX, cellY) && this.config.blockMove;
};

G.BoardLayer.prototype.isProperChunk = function(chunk) {
  return chunk.indexOf(this.config.editorSymbol) === 0;
};

G.BoardLayer.prototype.createToken = function(cellX, cellY, hp) {
  var elem = this.add(new this.config.constructor(this, cellX, cellY, hp));
  this.grid.set(cellX, cellY, elem);
  elem.grid = this.grid;
  return elem;
};

//true if something was imported
G.BoardLayer.prototype.import = function(cellX, cellY, chunk) {
  if (chunk.indexOf(this.config.editorSymbol) === 0) {
    if (this.config.hpToken) {
      this.createToken(
        cellX,
        cellY,
        chunk[this.config.editorSymbol.length]);
    }
    return true;
  }
  return false;
};

G.BoardLayer.prototype.export = function(cellX, cellY) {
  var elem = this.getToken(cellX, cellY);
  if (elem) {
    if (this.config.hpToken) {
      return this.config.editorSymbol + elem.hp;
    } else if (elem.export) {
      return elem.export();
    } else {
      return this.config.editorSymbol;
    }
  }
  return null;
};

G.BoardLayer.prototype.getRandom = function() {
  if (this.children.length == 0) return false;

  var len = this.children.length;
  var rnd = game.rnd.between(0, len);
  var elem;

  for (var i = 0; i < len; i++) {
    elem = this.children[i];
    if (elem && this.grid.get(elem.cellX, elem.cellY) == elem) {
      return elem;
    }
  }

  return false;
};

G.BoardLayer.prototype.removeToken = function(cellX, cellY) {
  var elem = this.grid.get(cellX, cellY);
  if (elem) {
    this.grid.set(cellX, cellY, false);
    if (this.config.collectableType) {
      G.sb("onCollectableRemove").dispatch(
        this.config.collectableType,
        elem,
        elem.frameName);
    }

    elem.deathAnimation();

    var candy = this.board.getCandy(cellX, cellY);
    if (candy) {
      if (this.config.blockMove) this.board.pushToFallCheckList(candy);
      if (this.config.blockMatch) {
        if (this.board.matcher.quickMatchCheck(candy)) {
          this.board.checkMatchList.push(candy);
        }
      }
    }
  }
};

// return true if match should be passed down
G.BoardLayer.prototype.onMatch = function(cellX, cellY) {
  var token = this.getToken(cellX, cellY);

  if (token) {
    token.onMatch();
    return this.config.stopMatchPropagation ? false : true;
  }

  return true;
};

// return true if hit shoud be passed down
G.BoardLayer.prototype.onHit = function(cellX, cellY) {
  var token = this.getToken(cellX, cellY);

  if (token) {
    token.onHit();
    return this.config.stopHitPropagation ? false : true;
  }

  return true;
};

G.BoardLayer.prototype.onBooster = function(cellX, cellY) {
  var token = this.getToken(cellX, cellY);

  if (token) {
    if (!token.onBooster()) {
      return false;
    }
  }
  
  return true;
};

G.BoardLayer.prototype.isCellFree = function(cellX, cellY) {
  return !this.grid.get(cellX, cellY);
};

G.BoardLayer.prototype.getToken = function(cellX, cellY) {
  return this.grid.get(cellX, cellY);
};

G.BoardLayer.prototype.getAllTokens = function() {
  var result = [];
  this.grid.loop(function(token, x, y) {
    if (token) result.push(token);
  });
  return result;
};

G.BoardLayer.prototype.isToken = G.BoardLayer.prototype.getToken;

G.BoardLayer.prototype.destroyCell = G.BoardLayer.prototype.removeToken; 